import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'swapin/pointvoucher', data),
  get: (vid) => Ajax('get', `swapin/pointvoucher/${vid}`),
  create: (data) => Ajax('post', 'swapin/pointvoucher/create', data),
  import: (data) => Ajax('post', 'swapin/pointvoucher/import', data),
  changeStatus: (vid, status) => Ajax('put', `swapin/pointvoucher/${vid}/changeStatus?status=${status}`),
};
